import { render, staticRenderFns } from "./page_bootstrap2.vue?vue&type=template&id=06c9f3db&scoped=true&"
import script from "./page_bootstrap2.vue?vue&type=script&lang=js&"
export * from "./page_bootstrap2.vue?vue&type=script&lang=js&"
import style0 from "./page_bootstrap2.vue?vue&type=style&index=0&id=06c9f3db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c9f3db",
  null
  
)

export default component.exports